var map = {
	"./decoration-icon-graphic.png": "595a",
	"./decoration-icon-name.png": "fe64",
	"./decoration-icon-number.png": "cdee",
	"./decoration-icon-text.png": "bdae",
	"./decoration-icon-uploads.png": "7a32"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "141c";